import React from "react";
import {autobind} from "core-decorators";
import {observer} from "mobx-react";

import "./TablePiecesActions.scss";
import {PiecesQuery} from "@/graphql/types";
import DeletePieceAction from "./DeletePieceAction";
import DownloadPieceAction from "./DownloadPieceAction";
import EditPieceAction from "./EditPieceAction";
import NewVersionAction from "./NewVersionAction";
import OpenPieceAction from "./OpenPieceAction";
import PublishAcion from "./PublishAction";

export interface ITablePiecesActionsProps {
  piece: PiecesQuery["pieces"][0];
  pieces: PiecesQuery["pieces"];
}

@autobind
@observer
export default class TablePiecesActions extends React.Component<ITablePiecesActionsProps> {
  public render() {
    const {piece, pieces} = this.props;
    return (
      <div className="TablePiecesActions">
        <OpenPieceAction piece={piece} />
        <DownloadPieceAction piece={piece} />
        <EditPieceAction piece={piece} pieces={pieces} />
        <PublishAcion piece={piece} />
        <NewVersionAction piece={piece} />
        <DeletePieceAction piece={piece} pieces={pieces} />
      </div>
    );
  }
}
